"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var DrawerWithCta = __importStar(require("./O_DrawerWithCta"));
var CheckoutItemGroup = __importStar(require("./O_CheckoutItemGroup"));
var material_1 = require("@mui/material");
var CtaButtonCombo = __importStar(require("./M_CtaButtonCombo"));
var sizing = __importStar(require("./sizing"));
var LoadingImage = __importStar(require("./A_LoadingImage"));
/** Entire save and share drawer */
var Component = function (p) {
    return (Preact.h(DrawerWithCta.Component, { platform: p.platform, portrait: p.portrait, sx: p.sx, open: p.open, onClose: p.onClose, title: p.title, titleButtonText: p.saveText, titleButtonOnClick: p.onSaveClick, confirmationBarContents: Preact.h(Box_1.default, { display: "grid", gridTemplateRows: p.leadTime || p.onArClick ? '1fr 1fr' : '1fr', gridTemplateColumns: "1fr 186px", gridTemplateAreas: "'leadTime ctaButtons' 'price ctaButtons'", padding: "24px", boxSizing: "border-box", sx: {
                height: {
                    xs: p.leadTime || p.onArClick ? '128px' : '84px',
                    md: p.leadTime || p.onArClick ? '140px' : '90px',
                },
            } },
            p.leadTime && (Preact.h(Box_1.default, { gridArea: "leadTime" },
                Preact.h(material_1.Typography, { variant: "h6", noWrap: true, color: "primary.dark" }, p.leadTime))),
            Preact.h(Box_1.default, { gridArea: "price", alignSelf: "end" },
                Preact.h(material_1.Typography, { variant: "body2", sx: { paddingBottom: '2px' }, color: "secondary.light" }, "".concat(p.totalPriceText, ": ")),
                Preact.h(material_1.Typography, { variant: "h4" },
                    Preact.h("strong", null, p.totalPrice)),
                p.savings && (Preact.h(material_1.Typography, { variant: "body2", color: "primary" }, p.savings))),
            Preact.h(Box_1.default, { gridArea: "ctaButtons", alignSelf: "end" },
                Preact.h(CtaButtonCombo.Component, { primaryOnClick: p.onFinaliseClick, primaryCopy: p.primaryCta, secondaryOnClick: p.onArClick, secondaryCopy: p.secondaryCta, size: p.platform === sizing.Platform.MOBILE ? 'medium' : 'large', disabled: false, orientation: "vertical" }))) },
        Preact.h(Box_1.default, { sx: { width: '100%', height: '245px' } }, p.open && (Preact.h(LoadingImage.Component, { loading: p.loading || p.snapshot === undefined, imageUrl: p.snapshot, error: p.error }))),
        Preact.h(CheckoutItemGroup.Component, { subheader: p.itemsHeader, items: p.items, originalPrice: p.totalPriceBeforeDiscount, savings: p.savings })));
};
exports.Component = Component;
